export type TsName = 'privod_bondar' | 'prop_broker'

export type SectionAccess = 'none' | 'limited' | 'full'

export type TradeAction =
  | 'createAccount'
  | 'financialOperations'
  | 'closeTrading'
  | 'accountSettings'
  | 'exchangeSettings'
  | 'traderProfile'

export type DivisionAction =
  | 'manageDivision'
  | 'accounts'
  | 'settings'

export interface SectionPermission<TAction extends string = never> {
  access: SectionAccess
  actions?: TAction[]
}

export interface PropPermissions {
  root: boolean
  sections: {
    trade: SectionPermission<TradeAction>
    divisions: SectionPermission<DivisionAction>
    securities: SectionPermission
    crm: SectionPermission
    report: SectionPermission
    messages: SectionPermission
    documents: SectionPermission
    inviteLinks: SectionPermission
    failedClosures: SectionPermission
  }
}

export interface Prop {
  id: number
  name: string
  slug: string
  support: string
  ts: TsName[]
  permissions: PropPermissions
}

export interface Profile {
  id: number
  props: Prop[]
}

export class ProfileError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'ProfileError'
  }
}

export class NoPropsError extends Error {
  constructor(message = 'No props found') {
    super(message)
    this.name = 'NoPropsError'
  }
}
